/**
 * Glifos de documento, compartidos por el árbol del sidebar, el buscador y el
 * menú de creación: las tres listas hablan de los mismos dos tipos de archivo,
 * así que tienen que verse igual.
 *
 * Llevan el azul de sistema adentro del SVG (y no vía `currentColor`) porque son
 * identidad, no estado: la fila puede estar apagada, en hover o seleccionada, y
 * el documento sigue siendo del mismo tipo.
 */

/** Markdown y PDF comparten marca: los dos son "una hoja que se lee". */
export const DOC_SVG =
  '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="var(--ui-selection)" stroke-width="1.6"><path d="M4.5 4.5H14L19.5 10V19.5H4.5Z"/><path d="M14 4.5V10H19.5"/></svg>';

/**
 * Carpeta. Una sola silueta, dos colores, según qué esté diciendo el glifo:
 *
 * - `FOLDER_SVG` sigue el color de la fila (`currentColor`): en el árbol la
 *   carpeta es estructura, no identidad, y acompaña al estado de su fila.
 * - `FOLDER_BRAND_SVG` va al azul de sistema: en el menú de creación la carpeta
 *   es una cosa que se crea, igual que un markdown o un canvas, y las tres
 *   tienen que leerse como la misma familia.
 *
 * El `path` es uno solo a propósito: si la silueta cambia, cambia en los dos
 * lados o dejan de ser la misma carpeta.
 */
const FOLDER_PATH = "M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z";

function folderSvg(stroke: string): string {
  return `<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="${stroke}" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="${FOLDER_PATH}"/></svg>`;
}

export const FOLDER_SVG = folderSvg("currentColor");
export const FOLDER_BRAND_SVG = folderSvg("var(--ui-selection)");

/** Los centros en 6/12/18 con r=1.75 dejan el bloque de 4.25 a 19.75: casi la
 *  misma caja óptica que el marco de la hoja (4.5 a 19.5), y por eso los dos
 *  glifos se leen alineados en la columna. */
export const CANVAS_SVG =
  '<svg viewBox="0 0 24 24" width="15" height="15" fill="var(--ui-selection)"><circle cx="6" cy="6" r="1.75"/><circle cx="12" cy="6" r="1.75"/><circle cx="18" cy="6" r="1.75"/><circle cx="6" cy="12" r="1.75"/><circle cx="12" cy="12" r="1.75"/><circle cx="18" cy="12" r="1.75"/><circle cx="6" cy="18" r="1.75"/><circle cx="12" cy="18" r="1.75"/><circle cx="18" cy="18" r="1.75"/></svg>';
